import { client } from "../dtos/Client";
import { Observable } from "rxjs/Observable";
import "rxjs/add/observable/from";
import * as Dtos from "../dtos/Tmd.dtos";

export const trialInstitutionLaboratoryFinanceApi = {
    getTrialInstitutionLaboratoryFinanceByTrialInstitutionLaboratoryId: (trialInstitutionLaboratoryId: number): Observable<Dtos.GetTrialInstitutionLaboratoryFinanceByTrialInstitutionLaboratoryIdResponse> => {
        //Create the request.
        let request: Dtos.GetTrialInstitutionLaboratoryFinanceByTrialInstitutionLaboratoryId = new Dtos.GetTrialInstitutionLaboratoryFinanceByTrialInstitutionLaboratoryId();
        request.trialInstitutionLaboratoryId = trialInstitutionLaboratoryId;

        //Send request.
        const response: Promise<Dtos.GetTrialInstitutionLaboratoryFinanceByTrialInstitutionLaboratoryIdResponse> = client.get(request);

        //Return request observable (incomplete request, still processing).
        return Observable.from(response);
    },
    getTrialInstitutionLaboratoryFinanceById: (id: number): Observable<Dtos.GetTrialInstitutionLaboratoryFinanceByIdResponse> => {
        //Create the request.
        let request: Dtos.GetTrialInstitutionLaboratoryFinanceById = new Dtos.GetTrialInstitutionLaboratoryFinanceById();

        request.id = id;

        //Send request.
        const response: Promise<Dtos.GetTrialInstitutionLaboratoryFinanceByIdResponse> = client.get(request);

        //Return request observable (incomplete request, still processing).
        return Observable.from(response);
    },
    setTrialInstitutionLaboratoryFinance: (trialInstitutionLaboratoryFinance: Dtos.TrialInstitutionLaboratoryFinance): Observable<Dtos.SetTrialInstitutionLaboratoryFinanceResponse> => {

        let request: Dtos.SetTrialInstitutionLaboratoryFinance = new Dtos.SetTrialInstitutionLaboratoryFinance();

        request.trialInstitutionLaboratoryFinance = trialInstitutionLaboratoryFinance;

        // send request
        const response: Promise<Dtos.SetTrialInstitutionLaboratoryFinanceResponse> = client.post(request);

        return Observable.from(response);
    },
    createTrialInstitutionLaboratoryFinance: (trialInstitutionLaboratoryId: number): Observable<Dtos.CreateTrialInstitutionLaboratoryFinanceResponse> => {
        //Create the request.
        let request: Dtos.CreateTrialInstitutionLaboratoryFinance = new Dtos.CreateTrialInstitutionLaboratoryFinance();

        request.trialInstitutionLaboratoryId = trialInstitutionLaboratoryId;

        //Send request.
        const response: Promise<Dtos.CreateTrialInstitutionLaboratoryFinanceResponse> = client.get(request);

        //Return request observable (incomplete request, still processing).
        return Observable.from(response);
    },
    validateTrialInstitutionLaboratoryFinance: (trialInstitutionLaboratoryFinance: Dtos.TrialInstitutionLaboratoryFinance): Observable<Dtos.ValidateTrialInstitutionLaboratoryFinanceResponse> => {

        let request: Dtos.ValidateTrialInstitutionLaboratoryFinance = new Dtos.ValidateTrialInstitutionLaboratoryFinance();

        request.trialInstitutionLaboratoryFinance = trialInstitutionLaboratoryFinance;

        // send request
        const response: Promise<Dtos.ValidateTrialInstitutionLaboratoryFinanceResponse> = client.post(request);

        return Observable.from(response);
    },
}